import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TypeActivityCraComponent } from './components/type-activity-cra/type-activity-cra.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { PagesComponent } from './components/pages/pages.component';
import { SettingsPermissionsComponent } from './components/settings-permissions/settings-permissions.component';
import { ListPermissionsComponent } from './components/list-permissions/list-permissions.component';
import { ChapitreEvalComponent } from './components/chapitre-eval/chapitre-eval.component';
import { MailingComponent } from './components/mailing/mailing.component';
import { RolesComponent } from './components/roles/roles.component';
import { TypeActivityTimesheetComponent } from './components/type-activity-timesheet/type-activity-timesheet/type-activity-timesheet.component';
import { PageintervanantComponent } from './components/pageintervanant/pageintervanant/pageintervanant.component';
import { clientFinalGuard } from '@core/guards/client-final.guard';
import { SubscriptionHasFeatureGuard } from 'app/guards/subscription-has-feature.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'type-activity-cra',
    pathMatch: 'full',
  },
  {
    path:'type-activity-cra',
    component:TypeActivityCraComponent,
    canActivate: [SubscriptionHasFeatureGuard],
    data: { featureName: 'CRA' },
  },
  {
    path:'type-activity-timesheet',
    component:TypeActivityTimesheetComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
/*   {
    path:'mode-payment',
    component:PaymentMethodComponent,
    // canActivate: [esnAbonneeGuard.canActivate]
  }, */
  // {
  //   path:'pages',
  //   component:PagesComponent,
  // },
  // {
  //   path:'pages-intervanant',
  //   component:PageintervanantComponent,
  // },
  {
    path:'permissions',
    component:SettingsPermissionsComponent,
  },
  {
    path:'list-permissions',
    component:ListPermissionsComponent
  },
  {
    path:'chapitre-evaluation',
    component:ChapitreEvalComponent
  },
  {
    path:'mailing',
    component:MailingComponent
  },
  {
    path:'roles',
    component:RolesComponent
  }
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
